import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
export default memo(shapeComponent(class ComponentsTranslationsLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    translation: instanceOfClassName("Translation").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, translation, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--translations--link", className)

    if (adminLayout) {
      return (
        <Link className={generatedClassName} to={this.to()} {...restProps}>
          {children || translation.key()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || translation.key()}
      </span>
    )
  }

  to() {
    const {adminLayout, translation} = this.p

    if (adminLayout) return Routes.adminTranslationPath(translation.id())

    return "#"
  }
}))
